export default __webpack_public_path__ + "static/Actions-web-checklist-create-65a84b94fc3782af8eafa6b836036cfc.png";